module.exports = __webpack_public_path__ + "static/media/zeya_drawing_02.4c17fe05.gif";